import { render } from "./DrawSelectAreaPage.vue?vue&type=template&id=5e8e1886"
import script from "./DrawSelectAreaPage.vue?vue&type=script&lang=js"
export * from "./DrawSelectAreaPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__